import React, { useState, useEffect } from 'react';
import { formatDate } from 'react-day-picker/moment';
import { DateTime } from 'luxon';
import _ from 'lodash';

import Label from '../../../components/label';
import InputNumeral from '../../../components/input-numeral';
import TextNumber from '../../../components/text-number';
import ReportButton from '../../../components/report-button';
import DayPicker from '../../../components/day-picker';
import LoaderType from '../../../components/loader-type';
import { getData, getFile } from '../../../helper/request-response';
import { downloadFile } from '../../../helper/util';
import constant from '../../../config/constant';
import loadPath from './config';

const List = () => {

    const [isLoad, setIsLoad] = useState(true);

    const [startDate, setStartDate] = useState(DateTime.local());

    const [endDate, setEndDate] = useState(DateTime.local());

    const [loadCost, setLoadCost] = useState([]);

    const [loadCostSummary, setLoadCostSummary] = useState({
        qty: 0,
        costLoad: 0
    });

    const onStartDateChange = day => {

        setStartDate(formatDate(day, constant.DEFAULT_DATE));
        setEndDate(formatDate(day, constant.DEFAULT_DATE));
    };

    const onEndDateChange = day => setEndDate(formatDate(day, constant.DEFAULT_DATE));

    const getLoadCost = () => {

        setIsLoad(true);

        const params = getParams();

        getData(loadPath.base, params).then(result => setLoadCost(result[0]));

        getData(loadPath.palmOilLoadSum, params).then(result => {

            if (!_.isEmpty(result[0])) {

                setLoadCostSummary(sum => ({
                    ...sum,
                    qty: result[0][0].qty,
                    costLoad: result[0][0].costLoad
                }));
            }

            setIsLoad(false);

        });

    }

    const getParams = () => {

        const params = {
            params: { 
                'start-date': DateTime.fromISO(startDate).toFormat(constant.PARAM_DATE_FORMAT),
                'end-date': DateTime.fromISO(endDate).toFormat(constant.PARAM_DATE_FORMAT)
            }
        };

        return params;
    }
    
    const onExport = e => {

        e.preventDefault();

        const params = getParams();

        getFile(loadPath.palmOilLoadExcel, params).then(response => downloadFile(response));

    }

    const onSubmit = e => {

        e.preventDefault();

        getLoadCost();

    }

    const onReset = e => {

        e.preventDefault();

        setStartDate(DateTime.local());

        getLoadCost();

    }

    useEffect(getLoadCost, []);

    return(
        <React.Fragment>
            <div className="card-header">
                <h3 className="h6 text-uppercase mb-0">{ loadPath.title }</h3>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-6 border-right">
                        <form className="form-horizontal" onSubmit={ e => onSubmit(e) }>
                            
                            <div className="form-group row">
                                <div className="col-md-6">
                                    <Label htmlFor="start-date" text="Tanggal Dari" />
                                    <DayPicker id="start-date" name="start-date" onDayChange={onStartDateChange} valueDate={ startDate } />
                                </div>
                                <div className="col-md-6">
                                    <Label htmlFor="end-date" text="Tanggal Ke" />
                                    <DayPicker id="end-date" name="end-date" onDayChange={onEndDateChange} valueDate={ endDate } />
                                </div>
                            </div>

                            <div className="form-group row">
                                <div className="col-md-12">
                                    <ReportButton isSubmit={ true } onClick={ onReset } onExport={ onExport }/>
                                </div>
                            </div>
                        </form>
                    </div>

                    {
                        !isLoad &&

                        <div className="col-md-6">
                            <div className="form-group row">
                                <div className="col-md-12">
                                    <h3>Rekapitulasi</h3>
                                </div>
                            </div>

                            <div className="form-group row">
                                <div className="col-md-6">
                                    <Label text="Kg" />
                                    <InputNumeral
                                        value={ loadCostSummary.qty }
                                        display={ true }
                                    />
                                </div>

                                <div className="col-md-6">
                                    <Label text="Rp" />
                                    <InputNumeral
                                        value={ loadCostSummary.costLoad }
                                        display={ true }
                                    />
                                </div>
                            </div>
                        </div>
                
                    }

                </div>

                {
                    isLoad &&
                    <LoaderType />
                }

                {
                    !isLoad && loadCost.length > 0 &&
                    <>
                        <br />

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="table-responsive">
                                    <table className="table table-striped table-hover card-text">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Kode Kendaraan</th>
                                                <th>No Kendaraan</th>
                                                <th>Harga (Rp)</th>
                                                <th>Muat Timbang (Kg)</th>
                                                <th>Total (Rp)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                loadCost.map((co, index) => {
                                                    return(
                                                        <tr key={ index }>
                                                            <th scope="row">{ index + 1 }</th>
                                                            <td>{ co.vehicleCode }</td>
                                                            <td>{ co.vehicleNo }</td>
                                                            <td><TextNumber value={ co.purchasePrice } /></td>
                                                            <td><TextNumber value={ co.qty } /></td>
                                                            <td><TextNumber value={ co.costLoad } /></td>
                                                        </tr>
                                                    );
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </>
                }
            </div>
        </React.Fragment>
    );
};

export default List;
